import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../../TTGAdmin/src/app/authentication/service/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(private _authenticationServices: AuthenticationService, private _router: Router) { }

  ngOnInit() {
    this._authenticationServices.logout();
    localStorage.clear();
    this._router.navigate(['/login']);
  }

}
